<template>
<div>
    <b-col cols="12" class="p-3 mb-2" style="border:solid 1px #DFDFDF;">
        
        <div class="text-left">
            <span>
                <b-badge variant="warning">Alert {{(alertIndex+1)}}</b-badge>
            </span>
            <span class="ml-2" v-if="isPepAlert">
                <b-badge variant="danger" class="mr-3">PEP</b-badge>
            </span>
            <span class="ml-2">
                <strong>CVIP: </strong>
                <b-badge variant="danger" class="mr-3">{{alert.alert.cvip || 'N/A'}}</b-badge>
            </span>
            <span class="ml-2">
                <strong>Match Score: </strong>
                <b-badge variant="danger" class="mr-3">{{alert.alert.matchScore}}</b-badge>
            </span>
            <span class="ml-2">
                <strong>Risk Score: </strong>
                <b-badge variant="danger" class="mr-3">{{alert.alert.riskScore}}</b-badge>
            </span>
            <span class="ml-4" v-if="!alertCollapse">
                <strong>{{alert.data.name}}</strong>
            </span>
            &nbsp;
            <font-awesome-icon :icon="alert.data.type == 'P' ? 'male' : 'building'" />

            <!-- <span class="ml-2" v-for="(category, index) in uniqueCategories" :key="index">
                <b-badge variant="dark" class="mr-3">{{category[0]}}: {{category[1]}}</b-badge>
            </span> -->

            <span class="ml-4" v-if="!alertCollapse && alertStatus=='pending'">
                <b-badge variant="primary">{{alertStatus}}</b-badge>
            </span>
            <span class="ml-4" v-if="!alertCollapse && (alertStatus!='pending' && alertStatus!='refer to ethixbase')">
                <b-badge :variant="alertStatus=='negative alert' ? 'success': 'danger'">{{alertStatus}}</b-badge>
            </span>

            <b-button @click="alertCollapse = !alertCollapse" variant="primary" class="float-right" size="sm">
                <font-awesome-icon :icon="alertCollapse ? 'minus' : 'plus'" />
            </b-button>
        </div>

        <div class="clearfix"></div>
        <b-collapse id="collapse-2" class="mt-2" v-model="alertCollapse">
            <h3>
                <small>
                    <span class="mr-1">
                        <b-badge variant="warning">Alert {{(alertIndex+1)}}</b-badge>
                    </span>
                </small>
                {{alert.data.name || 'Not Available'}}
                <span class="ml-4" v-if="alertStatus=='pending'">
                    <small>
                        <b-badge variant="primary">{{alertStatus}}</b-badge>
                    </small>
                </span>
                <span class="ml-4" v-if="alertStatus!='pending' && alertStatus!='refer to ethixbase'">
                    <small>
                        <b-badge :variant="alertStatus=='negative alert' ? 'success': 'danger'">{{alertStatus}}</b-badge>
                    </small>
                </span>
            </h3>

            <b-tabs content-class="mt-3 text-left">
                <b-tab :title="'Remediate Alert '+(alertIndex+1)" active>
                    <b-row>
                        <b-col cols="12">
                            <b-card no-body>
                                <b-nav pills card-header slot="header" v-b-scrollspy:nav-scroller>
                                    <b-nav-item :href="'#source'+alertIndex" @click="scrollIntoView">Sources </b-nav-item>
                                    <b-nav-item :href="'#sources-info'+alertIndex" @click="scrollIntoView">Sources Information</b-nav-item>
                                    <b-nav-item :href="'#events'+alertIndex" @click="scrollIntoView">Events</b-nav-item>

                                    <b-nav-item :href="'#aliases'+alertIndex" @click="scrollIntoView">Alaises</b-nav-item>
                                    <b-nav-item :href="'#position'+alertIndex" @click="scrollIntoView" v-if="alert.data.type =='P'">Position</b-nav-item>
                                    <b-nav-item :href="'#dob'+alertIndex" @click="scrollIntoView" v-if="alert.data.type =='P'">Date of Births</b-nav-item>
                                    <b-nav-item :href="'#addresses'+alertIndex" @click="scrollIntoView">Addresses</b-nav-item>
                                    <b-nav-item :href="'#attributes'+alertIndex" @click="scrollIntoView">Attributes</b-nav-item>
                                    <b-nav-item v-if="alert.data.relationships" :href="'#relationships'+alertIndex" @click="scrollIntoView">Relationships</b-nav-item>
                                </b-nav>

                                <b-card-body id="nav-scroller" ref="content" style="position:relative; height:300px; overflow-y:scroll;">
                                    <h4 :id="'source'+alertIndex">Source</h4>
                                    <b-row>
                                        <b-col cols="12">
                                            <p>
                                                <span>
                                                    <strong>Source Name:</strong>
                                                </span>
                                                &nbsp;{{alert.data.sourceItem.name || "Not Available"}}
                                            </p>
                                            <p>
                                                <span>
                                                    <strong>Type:</strong>
                                                </span>
                                                &nbsp;{{alert.data.sourceItem.type}}
                                            </p>
                                            <p>
                                                <span>
                                                    <strong>Source Date:</strong>
                                                </span>
                                                &nbsp; {{alert.data.sourceItem.date || "Not Available"}}
                                            </p>
                                            <p>
                                                <span>
                                                    <strong>Source Type:</strong>
                                                </span>
                                                &nbsp; {{alert.data.sourceItem.type || "Not Available"}}
                                            </p>

                                            <h4 :id="'events'+alertIndex">Events</h4>
                                            <div v-for="(event,eventIndex) in alert.data.event" v-if="Array.isArray(alert.data.event)">
                                                <rdc-alert-event :event="event" :eventIndex="eventIndex" :alertIndex="alertIndex"></rdc-alert-event>
                                            </div>
                                            <rdc-alert-event v-else :event="alert.data.event" :eventIndex="0" :alertIndex="alertIndex"></rdc-alert-event>

                                        </b-col>
                                    </b-row>
                                    <hr>
                                    <h4 :id="'sources-info'+alertIndex">Sources Information</h4>
                                    <div v-if="alert.data.sources && alert.data.sources.sourceItem.length">
                                        <div v-for="(source, eventIndex) in alert.data.sources.sourceItem">
                                            <p v-if="source.name">
                                                <span>Name: {{source.name || ''}}</span>
                                            </p>
                                            <p v-if="source.url">
                                                <strong>URL:</strong>
                                                <a :href="source.url" target="_blank">{{source.url}}</a>
                                            </p>
                                        </div>
                                    </div>
                                    <hr>

                                    <h4 :id="'aliases'+alertIndex">Aliases</h4>
                                    <p v-if="alert.data.alias">{{ getAlaises(alert.data.alias) }}</p>
                                    <hr>
                                    <h4 :id="'position'+alertIndex" v-if="alert.data.type =='P'">Positions</h4>
                                    <div v-if="alert.data.type =='P' && alert.data.position && Array.isArray(alert.data.position)">
                                        <p v-for="(position,index) in alert.data.position"><span>{{index+1}}: {{position.position}}</span></p>
                                    </div>

                                    <h4 v-if="alert.data.type =='P'" :id="'dob'+alertIndex">Date Of Births</h4>
                                    <div v-if="alert.data.type =='P' && alert.data.dob && Array.isArray(alert.data.dob)">
                                        <p v-for="(dob,index) in alert.data.dob"><span>{{index+1}}: {{alert.data.dob}}</span></p>
                                    </div>

                                    <p v-if="alert.data.type =='P' && alert.data.dob && (typeof alert.data.dob == 'string')"><span>{{alert.data.dob}}</span></p>
                                    <hr>
                                    <h4 :id="'addresses'+alertIndex">Addresses</h4>

                                    <div v-for="(address,addIndex) in alert.data.address" :key="addIndex">
                                        <span>{{addIndex+1}}</span>&nbsp;&nbsp;
                                        <strong>Address: </strong><span>{{address.address1 || 'N/A'}}</span>&nbsp;
                                        <strong>City: </strong><span>{{address.city || 'N/A'}}</span>&nbsp;
                                        <strong>State: </strong><span>{{address.state || 'N/A'}}</span>&nbsp;
                                        <strong>Postal Code: </strong><span>{{address.postalCode || 'N/A'}}</span>&nbsp;
                                        <strong>Counrty: </strong><span>{{address.country || 'N/A'}}</span>&nbsp;
                                        <hr>
                                    </div>
                                    <hr>
                                    <h4 :id="'attributes'+alertIndex">Attributes</h4>
                                    <div v-for="(attr,attrIndex) in alert.data.attribute">
                                        <!-- <pre>{{alert.data.attribute}}</pre> -->
                                        <p>
                                            <b-badge variant="primary" :id="'category-tooltip-target-'+alertIndex+'-'+attrIndex">
                                                <span>{{attr.code}}</span>
                                            </b-badge>
                                            : {{attr.value || 'N/A'}}
                                            <b-img rounded :height="100" v-if="attr.code=='IMG'" :src="attr.value"></b-img>
                                        </p>

                                        <b-tooltip v-if="attr.code !='IMG'" :target="'category-tooltip-target-'+alertIndex+'-'+attrIndex">{{getAttributeDescription(attr.code)}}</b-tooltip>

                                    </div>
                                    <hr>
                                    <h4 v-if="alert.data.relationships" :id="'relationships'+alertIndex">Relationships</h4>
                                    <div v-if="alert.data.relationships">
                                        <p v-for="(relationship) in alert.data.relationships.relationship">

                                            <strong>Name:</strong> {{relationship.name || 'N/A'}} <strong>Type:</strong> {{relationship.type || 'N/A'}} <strong>Direction:</strong> {{relationship.direction || 'N/A'}}
                                        </p>
                                        <hr>
                                    </div>

                                </b-card-body>
                            </b-card>
                        </b-col>

                    </b-row>
                </b-tab>
                <b-tab title="Predictive Remediation Match">
                    <pre>{{alert.predictiveRemediationMatch}}</pre>
                </b-tab>

            </b-tabs>
        </b-collapse>
    </b-col>
</div>
</template>

<script>
import {
    mapGetters,
    mapState
} from "vuex";
import rdcAlertEvent from "./RDCAlertEvent.vue";
import eventCategoryCode from "../../utils/remediationJson/eventCategoryCode.json";
import eventSubCategoryCode from "../../utils/remediationJson/eventSubCategoryCode.json";
import entityAttributeCode from "../../utils/remediationJson/entityAttributeCodes.json";
import pepCode from "../../utils/remediationJson/pepCodes.json";
export default {
    name: "RDCAlert",
    components: {
        rdcAlertEvent
    },
    data() {
        return {
            isPepAlert: false,
            alertCollapse: false,
            alertStatus: "pending",
            date: null,
            remediationOptions: ["pending", "postive alert", "negative alert"],

            rdcDictionaryEventCategoryCode: eventCategoryCode.EventCategoryCode,
            rdcDictionaryEventSubCategoryCode: eventSubCategoryCode.EventSubCategoryCode,
            rdcDictionaryPepCodes: pepCode.PEPCodes,
            rdcDictionaryAttributeCodes: entityAttributeCode.EntityAttributeCode,

            // for ctegories
            uniqueCategories: [],
            uniqueSubCategories: [],
            secUniqueCount: 0
        };
    },
    created() {},
    mounted() {
        // console.log('alert',this.alert)
        this.alertStatus = "pending";
        if (this.alert.data.event) {
            this.getUniqueCategories(this.alert.data.event);
        }

    },
    validations: {},
    computed: {
        ...mapGetters([]),
        ...mapState(["toggleAllCoppalse"])
    },
    watch: {
        toggleAllCoppalse(value) {
            this.collapse = value;
        }
    },
    methods: {
        readableBytes(bytes) {
            var i = Math.floor(Math.log(bytes) / Math.log(1024)),
                sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

            return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i];
        },

        onUploadImage(file, progress, bytesSent) {
           
            EventBus.$emit("onUploadStart", "uploading image");
        },

        onUploadFinish() {
           
            EventBus.$emit("onUploadCompleting", "uploading image");
        },

        vsuccess(file, response) {
            
            let self = this;
            let uploadedFile = {};
            if (response && response.url) {
                this.imgSrc = response.url;
                uploadedFile = {
                    fileId: uid(),
                    filename: file.name,
                    caption: {
                        english: this.slideCaption
                    },
                    text: {
                        english: this.slideText
                    },
                    size: file.size,
                    type: file.type,
                    url: response.url
                };
                self.files.push(uploadedFile);
                // this.$refs.myVueDropzone.removeAllFiles();
                this.$refs.myVueDropzone.removeFile(file);
            }
        },

        /**
         * dropzone js send additional params
         */
        sendingEvent(file, xhr, formData) {
            formData.append("formId", this.form.formId);
            formData.append("fieldId", this.fieldData.id);
            formData.append("fieldIndex", this.fieldIndex);
            formData.append("sectionIndex", this.fieldIndex);
            formData.append("sectionId", this.fieldIndex);
        },
        // Convenience method to scroll a heading into view.
        // Not required for scrollspy to work
        scrollIntoView(evt) {
            evt.preventDefault();
            const href = evt.target.getAttribute("href");
            const el = href ? document.querySelector(href) : null;
            if (el) {
                this.$refs.content.scrollTop = el.offsetTop;
            }
        },

        getAlaises(alias) {

            if (Array.isArray(alias)) {

                let jsn = alias;

                return jsn.join(", <br />");
            }

            return alias;

        },

        // for alerts calculations
        onUpdateStatus(status, alert) {
            // // console.log("onUpdateStatus", status, alert)
            this.$emit("getStatus", status, alert);
        },
        //-----for categories
        getUniqueCategories(alertEvents) {

            let counts = {};
            if (Array.isArray(alertEvents) && alertEvents.length > 0) {
                alertEvents.forEach(alert => {
                    counts[alert.category] = (counts[alert.category] || 0) + 1;
                    if (alert.category == 'PEP') {
                        this.isPepAlert = true;
                    }
                });
            } else {
                counts[alertEvents.category] = (counts[alertEvents.category] || 0) + 1;
                if (alertEvents.category == 'PEP') {
                    this.isPepAlert = true;
                }
            }

            this.uniqueCategories = Object.entries(counts);
        },
        getEventCategoryDescription(code) {

            let description;

            this.rdcDictionaryEventCategoryCode.map(event => {

                if (event.Code == code) {
                    description = event.Description || '';
                }

            });
            return description;
        },
        getEventSubCategoryDescription(code) {

            let description;

            this.rdcDictionaryEventSubCategoryCode.map(event => {

                if (event.Code == code) {
                    description = event.Description || '';
                }

            });
            return description;
        },
        getAttributeDescription(code) {

            let description;

            this.rdcDictionaryAttributeCodes.map(attr => {

                if (attr.Code == code) {
                    description = attr.Description || '';
                }

            });
            return description;
        }

    },
    props: {
        alert: Object,
        alertIndex: Number
    }
};
</script>
